<script>
/**
 * @overview 游戏编辑
 *
 * @author huojinzhao
 */

import mapUtils, { $form, http } from "@/utils";
import FormCom from '../../../components/FormComponents/index.vue';
import * as gameManageServer from '../../../api/gameManage';

export default {
  name: "GameGameListEditor",
  components: {
    FormCom,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },

    type: {
      type: [String, Number],
      required: true,
    },
    typeTwo: {
      type: [String, Number],
    },

    data: {
      type: Object,
      default: null,
    },
  },

  data: () => ({
    // 游戏类型选择列表
    scoreList: [],
    // 配置选中的数据
    config_json: {
      currency: {
        value: null,
        options: [],
        config: null,
      },
      subject: {
        value: null,
        options: [],
        config: null,
      },
    },
    config_id: null, // 通用配置模版id
    // 通用配置模版选中
    config_select: '',
    // 游戏关联配置
    gameOptions: [],
    // 预览表单数据
    preForm: [],
    formData: null,

    outsource: {
      name: "",
      url: "",
    },

    recorder: {
      name: "",
      config: {
        src: [
          {
            image: "",
            audio: "",
            text: "",
          },
        ],
      },
    },

    loading: {
      submit: false,
    },

    recorderErrors: [],

    rules: {
      name: [
        $form.rules.required("游戏名称"),
      ],

      // nick_name: [
      //   $form.rules.required("游戏中文名称"),
      // ],

      // mode: [
      // $form.rules.required("游戏模式", "number"),
      // ],

      // form_type: [
      //   $form.rules.required("游戏表单模式"),
      // ],

      // url: [
      //   $form.rules.required("游戏文件"),
      // ],

      english_name: [
        $form.rules.required("游戏包名称"),
      ],
    },
  }),

  computed: {
    // 是否是课中表单
    isInClass() {
      return `${this.type}` === '30';
    },
    isOutsource() {
      return this.type !== 1;
    },

    isCreate() {
      return !this.data;
    },

    gameInit() {
      return this.isOutsource ? this.outsource : this.recorder;
    },
  },

  watch: {
    visible(value) {
      if (value) {
        this.init();
        this.$nextTick(this.clearValidate);
      } else {
        this.formData = null;
      }
    },
  },

  methods: {
    ...mapUtils("form", ["submit", "errorAlert"]),

    // 获取游戏类型
    getGameSceneTypeList() {
      // 获得课程编辑配置信息
      gameManageServer.queryGameSceneType().then((data) => {
        if (data.game_theme_types && Array.isArray(data.game_theme_types)) {
          data.game_theme_types.map((v) => {
            if (v.type_id === 6) {
              this.scoreList = v.leaf && v.leaf.filter(q => q.type_id !== q.parent_type_id);
            }
          });
        }
      });
    },
    // 通用类型改变
    async handleChange(name) {
      console.log('customer', name);
      let res = null;
      switch (name) {
        case '通用配置':
          // 3
          res = await gameManageServer.queryGameSceneList({ type_id: 3 });
          this.setOptions(res, 'currency');
          break;
        case '题目内容':
          // 4
          res = await gameManageServer.queryGameSceneList({ type_id: 4 });
          this.setOptions(res, 'subject');
          break;
      }
    },
    // 设置options数据
    setOptions(res, key) {
      if (res && res.data) {
        this.gameOptions = res.data.map(v => ({
          value: v.id,
          label: v.name,
        }));
      }
      this.config_id = this.config_json[key].value;
      this.preForm = this.config_json[key].config;
      this.config_json[key].options = this.gameOptions;
    },
    // 选择通用配置模版
    handleSelectTemp(value) {
      console.log('handleSelectTemp', value, this.config_select);
      switch (this.config_select) {
        case '通用配置':
          // 3
          this.setOptionsValue(value, 'currency');
          break;
        case '题目内容':
          // 4
          this.setOptionsValue(value, 'subject');
          break;
      }
    },
    // 设置选中的模版
    async setOptionsValue(value, key) {
      console.log('setOptionsValue', value, key);
      this.config_json[key].value = value;
      let newArr = [];
      if (!value) {
        this.config_json[key].config = newArr;
        this.preForm = newArr;
        return false;
      }
      // 获取预览表单数据
      const res = await gameManageServer.queryGameSceneDetail({ id: value });
      console.log('获取预览数据', res);
      if (res.json_config_original) {
        const obj = JSON.parse(res.json_config_original);
        let arr = obj.layout;
        if (Array.isArray(arr)) {
          arr = arr.filter(v => v.config);
          arr.map((v) => {
            newArr = newArr.concat(v.config);
          });
        }
        this.config_json[key].config = newArr;
        this.preForm = newArr;
      }
    },
    init() {
      // 获取游戏类型列表
      this.getGameSceneTypeList();

      const data = this.data || this.gameInit;
      this.formData = { type: this.typeTwo || this.type, ...data };

      // 编辑时 初始话配置数据
      try {
        if (this.data.form_set_details) {
          const obj = JSON.parse(this.data.form_set_details);
          this.config_json = obj;
          const selectName = '通用配置';
          this.config_select = selectName;
          this.handleChange(selectName);
        }
      } catch (e) {
        console.log('初始化赋值失败==>', e);
      }
    },

    validate() {
      let result = true;

      this.$refs.form.validate((valid) => {
        result = result && valid;
      });

      result = this.isOutsource
        ? result
        : result && this.recorderValidate();

      result && this.submit();
    },

    async submit() {
      this.loading.submit = true;

      const url = `${this.type}` === '30' ? "/resource" : "/game"; // 课件type = 30
      if (`${this.type}` === '30') {
        if (this.formData.url) this.formData.name = this.formData.url.split("/").pop();

        // 如果资源包不存在 则不上传name & url 字段
        if (!this.formData.name || !this.formData.url) {
          delete this.formData.name;
          delete this.formData.url;
        }
      }

      // 判断如果游戏类型的值为字符串，新增游戏类型，否则直接拿游戏类型的id
      if (this.formData.game_theme_type_id && typeof this.formData.game_theme_type_id === 'string') {
        const id = await gameManageServer.addGameType({ name: this.formData.game_theme_type_id, parent_type_id: 6 });
        this.formData.game_theme_type_id = id;
      }

      // 预览字段处理
      this.formData.form_set_details = JSON.stringify(this.config_json);

      this.$form_submit({
        id: this.formData.id,
        uri: url,
        data: this.formData,
      })
        .then(() => {
          this.$emit("success", this.formData.id);
          this.cancel();
        })
        .catch(this.$form_errorAlert)
        .finally(() => {
          this.loading.submit = false;
        });
    },

    cancel() {
      this.config_id = null;
      this.preForm = [];
      this.gameOptions = [];
      this.config_json = {
        currency: {
          value: null,
          options: [],
          config: null,
        },
        subject: {
          value: null,
          options: [],
          config: null,
        },
      };
      this.$emit("update:visible", false);
    },

    clearValidate() {
      this.$refs.form.clearValidate();

      this.recorderErrors = [];
    },

    recorderValidate() {
      const errorMessage = "游戏资源包含图片、音频、文字，必须补充完整";

      const list = this.formData.config.src;

      let result = true;

      this.recorderErrors = list.map(({
        text,
        image,
        audio,
      }) => {
        const valid = !!(text && image && audio);

        result = result && valid;

        return valid ? "" : errorMessage;
      });

      return result;
    },

    recorderAppend() {
      const list = this.formData.config.src;

      const valid = this.recorderValidate();

      valid && list.push({ image: "", audio: "", text: "" });
    },

    recorderDelete(index) {
      const list = this.formData.config.src;

      list.splice(index, 1);
    },
  },
};
</script>

<template>
  <el-dialog
    v-if="formData"
    :show-close="false"
    :visible="visible"
    width="760px"
    class="game-list-editor"
  >
    <div slot="title">
      {{ isCreate ? '创建游戏' : '编辑游戏' }}
    </div>

    <!-- 游戏公司游戏 -->
    <el-form
      v-if="isOutsource"
      ref="form"
      :model="formData"
      :rules="rules"
      label-width="7em"
    >
      <el-form-item
        v-if="!isInClass"
        label="游戏名称"
        prop="name"
      >
        <el-input
          v-model="formData.name"
          placeholder="请输入游戏名称"
        />
      </el-form-item>

      <el-form-item
        v-if="isInClass"
        label="游戏模式"
        prop="mode"
      >
        <el-input
          v-model.number="formData.mode"
          type="number"
          placeholder="请输入游戏模式"
        />
      </el-form-item>

      <el-form-item
        v-if="isInClass"
        label="游戏中文名"
        prop="nick_name"
      >
        <el-input
          v-model="formData.nick_name"
          type="text"
          placeholder="请输入游戏中文名称"
        />
      </el-form-item>

      <el-form-item
        v-if="isInClass"
        label="游戏类型"
        prop="type_game"
      >
        <div class="select-box-game-type">
          <el-select
            v-model="formData.game_theme_type_id"
            :allow-create="true"
            clearable
            filterable
            placeholder="请输入或选择">
            <el-option
              v-for="item in scoreList"
              :key="item.type_id"
              :label="item.name"
              :value="item.type_id"/>
          </el-select>
        </div>
      </el-form-item>

      <el-form-item
        v-if="isInClass"
        label="表单模式"
        prop="form_type"
      >
        <el-input
          v-model.number="formData.form_type"
          type="number"
          placeholder="请输入游戏表单模式"
        />
      </el-form-item>

      <el-form-item
        label="游戏文件"
        prop="url"
      >
        <app-qiniu
          v-model="formData.url"
          token-url="/resource/upload_token"
          token-mode="name"
          width="100%"
          height="100%"
          type="rar"
          preview
        >
          <span
            slot="placeholder"
            class="state-primary-icon"
          >
            选择需要上传游戏的压缩包
          </span>
        </app-qiniu>
      </el-form-item>

      <el-form-item
        v-if="isInClass"
        label="游戏包名称"
        prop="english_name"
      >
        <el-input
          v-model.number="formData.english_name"
          type="text"
          placeholder="请输入游戏包名称(英文)"
        />
      </el-form-item>

      <el-form-item
        v-if="isInClass"
        label="游戏封面"
        prop="image"
        class="game_img"
      >
        <FileDialog
          v-model="formData.cover_image_url"
          width="100%"
          height="100%"
          type="image"
          preview
        >
          <span
            slot="placeholder"
            class="layout-placeholder"
          >
            选择图片
          </span>
        </FileDialog>
      </el-form-item>

      <el-form-item
        v-if="isInClass"
        label="配置说明"
        prop="form_set_explain"
      >
        <el-input
          v-model="formData.form_set_explain"
          :rows="2"
          type="textarea"
          placeholder="请填写配置说明"
          resize="none"
        />
      </el-form-item>

      <el-form-item
        v-if="isInClass"
        label="表单配置选择"
        prop="config_select"
      >
        <div class="config-box">
          <el-radio-group
            v-model="config_select"
            @change="handleChange"
          >
            <el-radio-button label="通用配置"/>
            <el-radio-button label="题目内容"/>
            <!--<el-radio-button label="评分规则"/>-->
            <!--<el-radio-button label="游戏场景"/>-->
          </el-radio-group>
        </div>
      </el-form-item>

      <el-form-item
        v-if="isInClass"
        label="通用配置模版"
        prop="config_id"
      >
        <div class="config-box">
          <el-select
            v-model="config_id"
            :clearable="true"
            placeholder="请选择"
            @change="handleSelectTemp"
            @clear="handleSelectTemp"
          >
            <el-option
              v-for="item in gameOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"/>
          </el-select>
        </div>
      </el-form-item>
    </el-form>
    <div
      v-if="isInClass"
      class="pre-form-box">
      <div class="pre-form-name">表单预览</div>
      <FormCom
        :form="preForm"
      />
    </div>
    <!-- 自己的recorder游戏 -->
    <el-form
      v-else
      ref="form"
      :model="formData"
      :rules="rules"
      label-width="6em"
    >
      <el-form-item
        label="游戏名称"
        prop="name"
      >
        <el-input
          v-model="formData.name"
          placeholder="请输入游戏名称"
        />
      </el-form-item>
      <el-form-item
        v-for="(src, index) in formData.config.src"
        :key="src.audio"
        :error="recorderErrors[index]"
        class="game-list-editor__recorder"
        label="游戏资源"
        required
      >
        <app-qiniu
          v-model="src.image"
          :title="src.image"
          token-url="/upload/token"
          token-mode="type"
          height="100%"
          type="image"
          preview
        >
          <span
            slot="placeholder"
            class="layout-placeholder"
          >
            选择图片
          </span>
        </app-qiniu>
        <app-qiniu
          v-model="src.audio"
          :title="src.audio"
          token-url="/upload/token"
          token-mode="type"
          height="100%"
          type="audio"
          preview
        >
          <span
            slot="placeholder"
            class="layout-placeholder"
          >
            选择音频
          </span>
        </app-qiniu>
        <el-input
          v-model="src.text"
          placeholder="请输入对应内容"
        />

        <AppIcon
          type="delete"
          @click="() => recorderDelete(index)"
        />
      </el-form-item>

      <el-form-item
        class="game-list-editor__recorder-append"
      >
        <el-button
          type="primary"
          icon="el-icon-plus"
          plain
          round
          @click="recorderAppend"
        >
          添加游戏资源
        </el-button>
      </el-form-item>
    </el-form>

    <AppFormSubmit
      slot="footer"
      :submitting="loading.submit"
      @submit="validate"
      @cancel="cancel"
    />
  </el-dialog>
</template>

<style lang="postcss">
.select-box-game-type{
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex: 1;
}
/* 重置element-ui */
.pre-form-name{
  text-align: center;
  width: 100%;
  margin-bottom: 20px;
}
.pre-form-box{
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-around;
  border: 2px dashed #00bfff;
  border-radius: 6px;
  min-height: 60px;
  padding: 20px;
  position: relative;
}
.pre-form-box:before{
  content: '';
  position: absolute;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  background-color: rgba(255,255,255,.5);
  z-index: 99;
}

.config-box{
  display: flex;
  flex: 1;
}

.game-list-editor .el-form-item__content {
  display: flex;
  justify-content: center;
  align-items: center;
  height: initial !important;
}

.game-list-editor .el-input {
  //flex-grow: 1;
}

.game-list-editor .el-input__inner {
  border-radius: var(--bd-radius);
}

/* 组件样式 */

.game-list-editor__recorder .app-create-label {
  margin-right: 10px;
}

.game-list-editor__recorder .iconfont {
  font-size: 20px;
  margin: 0 10px;
}

.game-list-editor__recorder:nth-child(2)
  .el-form-item__content > .app-icon {
  visibility: hidden;
}

.game-list-editor__recorder-append {
  margin-bottom: 0 !important;
}

.game-list-editor__recorder-append .el-form-item__content {
  margin-left: 20px !important;
  display: flex;
  justify-content: center;
}

.game-list-editor__control.el-button {
  margin-left: 20px;
}
</style>
